import { IOrderLifetimeRuleStoreSegment } from './orderLifetimeRule.interface';

export const orderLifetimeRuleStoreSelector = (state: IOrderLifetimeRuleStoreSegment) => state.orderLifetimeRule;
